import { useEffect, useRef, useState } from 'react';

interface UseAnimationOptions {
  threshold?: number;
  delay?: number;
  triggerOnce?: boolean;
}

export function useAnimation(options: UseAnimationOptions = {}) {
  const { threshold = 0.1, delay = 0, triggerOnce = true } = options;
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
          if (triggerOnce) {
            observer.unobserve(element);
          }
        } else if (!triggerOnce) {
          setIsVisible(false);
        }
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [threshold, delay, triggerOnce]);

  return { ref, isVisible };
}
